<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useLayoutStore } from "@/stores/layout";

const layoutStore = useLayoutStore();
const { growthValuesDialog } = storeToRefs(layoutStore);

const visible = computed({
  get: () => !!growthValuesDialog.value.dialog,
  set: (v) => {
    if (!v) layoutStore.closeGrowthValuesDialog();
    else layoutStore.openGrowthValuesDialog();
  },
});

const leftRows = [
  { concern: "Pass QA Test, Pass TL", points: "+3 Points" },
  { concern: "Pass TESOL", points: "+5 Points" },
  { concern: "Complete Personal Information", points: "+2 Points" },
  { concern: "Contract Signing", points: "+2 Points" },
  { concern: "Complete Popular Course Training", points: "+5 Points" },
  { concern: "Complete the First Class", points: "+0.5 Points" },
  { concern: "Leave Class Remarks after Class", points: "+0.25 Points/+0.5 Points" },
  { concern: "Get a Pet", points: "+1 Points" },
  { concern: "Confirmation of Available Class Schedule", points: "+1 Points" },
  { concern: "Course Learning", points: "+(2~5) Points" },
  { concern: "Clock in on Time Every Day", points: "+0.2 Points" },
  { concern: "Finish Class", points: "+0.5 Points/+0.75 Points" },
  { concern: "Get 5 Stars", points: "+4 Points" },
  { concern: "Taking Photos with Students in Class Happily", points: "+0.25 Points" },
  { concern: "Confirmation of Available Class Schedule", points: "+1 Points" },
];

const rightRows = [
  { concern: "Successful Trial Conversion", points: "+2 Points" },
  { concern: "Schedule Classes One Week in Advance", points: "+2 Points" },
  { concern: "Get Flowers", points: "+4 Points" },
  { concern: "Weekly Task-Complete 80 Lessons", points: "+5 Points" },
  { concern: "Weekly Tasks-Gain at Least 72 Positive Feedback", points: "+5 Points" },
  { concern: "MT Training Assessment", points: "+(3~8) Points" },
  { concern: "Refer a Teacher and Open an Account Successfully", points: "+1 Points" },
  { concern: "Refer a Teacher and Start the Class Successfully", points: "+20 Points" },
  { concern: "Absence", points: "-8 Points" },
  { concern: "Cancellation (courses within 3 hours within 24 hours)", points: "-4 Points" },
  { concern: "Cancellation (courses within 3h)", points: "-3 Points" },
  { concern: "Complaint", points: "-5 Points" },
  { concern: "No Class for 7 Consecutive Days", points: "-5 Points" },
  { concern: "The Teacher Returns", points: "0" },
  { concern: "", points: "" },
];
</script>

<template>
  <el-dialog
    v-model="visible"
    title="Growth System & Growth Value Rules"
    width="1058px"
    class="growth-values-dialog"
    align-center
    append-to-body
  >
    <p class="intro">
      In Acadsoc, tutors can gain growth values every time when they complete a course or special
      project. Good grades from students or parents can give you extra values. However, not being
      punctual or not fulfilling the timetable you specify will make your efforts in vain.
    </p>
    <p class="intro mb-0">
      At the beginning, every tutor starts at level 1 (LV.1). After gaining the growth value, they
      will be promoted to level 8 (LV.8). The higher the level, the more rights you will gain while
      you improve yourself.
    </p>

    <div class="growth-rules">
      <el-table :data="leftRows" class="common-table left-table" :show-header="true">
        <el-table-column prop="concern" label="Data in Concern" min-width="200" />
        <el-table-column label="Points Gained" min-width="140">
          <template #default="{ row }">
            <span v-html="row.points" />
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="rightRows" class="common-table right-table" :show-header="true">
        <el-table-column prop="concern" label="Data in Concern" min-width="200" />
        <el-table-column label="Points Gained" min-width="140">
          <template #default="{ row }">
            <span v-html="row.points" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
.intro {
  color: #32397a;
  margin: 0 0 12px;
  line-height: 1.5;
  font-size: 14px;
}

.mb-0 {
  margin-bottom: 0;
}

.growth-rules {
  display: flex;
  margin-top: 16px;
  box-shadow: 0 0 10px rgba(125, 162, 255, 0.3);
  border-radius: 16px;
  overflow: hidden;
}

.left-table,
.right-table {
  flex: 1;
  box-shadow: none !important;
  border: 0 !important;
  border-radius: 0 !important;
}

.left-table {
  border-right: 1px solid rgba(50, 57, 122, 0.08) !important;
}
</style>
